import { css } from "@emotion/react"

export const rowItem = css`
    width: 100%;

    button {
        width: 100%;
        border-radius: 0 !important;
    }
`
